module.exports = __webpack_public_path__ + "img/plan-bg.38e07a45.png";